import { productFormAddedItemsEvent, productFormName } from '@/components/ui';
import { cartDrawerName, cartDrawerUpdateEvent } from '@/sections/cart-drawer';
import { cartOverviewName, cartOverviewUpdateEvent } from '@/sections/cart-overview';
import { StickySection, defineSection } from '@decify/cell-shopify/client';
import './site-header.scss';
export const SiteHeaderName = 'SiteHeader';
export const SiteHeaderTagName = 'cell-section-site-header';
class SiteHeader extends StickySection {
    domParser;
    constructor() {
        super(SiteHeaderName);
        this.validateProps(['sectionId']);
        this.domParser = new DOMParser();
        this.handleCartUpdate = this.handleCartUpdate.bind(this);
    }
    componentDidMount() {
        super.componentDidMount();
        globalThis.subscribe(`${productFormName}.${productFormAddedItemsEvent}`, this.handleCartUpdate);
        globalThis.subscribe(`${cartDrawerName}.${cartDrawerUpdateEvent}`, this.handleCartUpdate);
        globalThis.subscribe(`${cartOverviewName}.${cartOverviewUpdateEvent}`, this.handleCartUpdate);
    }
    // TODO: Fix this type error.
    // @ts-ignore
    handleCartUpdate(data) {
        const html = data.sections[this.props.sectionId];
        if (!html) {
            throw new Error('HTML not found');
        }
        this.render(this.domParser.parseFromString(html, 'text/html'));
    }
    render(doc) {
        this.querySelectorAll('[cell-update]').forEach((element) => {
            const newElement = doc.querySelector(`[cell-update="${element.getAttribute('cell-update')}"]`);
            if (newElement) {
                element.replaceWith(newElement);
            }
        });
    }
}
defineSection(SiteHeaderTagName, SiteHeader);
